import type { NodeState, SessionState } from '../types';

export interface Meta {
  label: string;
  color: string;
  soft: string;
  icon: string;
  anim?: 'pulse' | 'slow';
  bordered?: boolean;
}

export const SESSION_META: Record<SessionState, Meta> = {
  interpreting: {
    label: 'Sto capendo',
    color: 'var(--accent)',
    soft: 'var(--accent-soft)',
    icon: 'sparkles',
    anim: 'pulse',
  },
  awaiting_clarification: {
    label: 'Aspetta un chiarimento',
    color: 'var(--warn)',
    soft: 'var(--warn-soft)',
    icon: 'message-circle-question',
    anim: 'slow',
    bordered: true,
  },
  planning: {
    label: 'Sto pianificando',
    color: 'var(--accent)',
    soft: 'var(--accent-soft)',
    icon: 'route',
    anim: 'pulse',
  },
  running: {
    label: 'In lavorazione',
    color: 'var(--accent)',
    soft: 'var(--accent-soft)',
    icon: 'play',
    anim: 'pulse',
  },
  awaiting_human: {
    label: 'Aspetta te',
    color: 'var(--warn)',
    soft: 'var(--warn-soft)',
    icon: 'hand',
    anim: 'slow',
    bordered: true,
  },
  suspended: {
    label: 'Sospesa',
    color: 'var(--faint)',
    soft: 'var(--neutral-soft)',
    icon: 'pause',
  },
  completed: {
    label: 'Conclusa',
    color: 'var(--ok)',
    soft: 'var(--ok-soft)',
    icon: 'check-circle-2',
  },
  blocked: {
    label: 'Bloccata',
    color: 'var(--danger)',
    soft: 'var(--danger-soft)',
    icon: 'octagon-alert',
    anim: 'slow',
  },
  failed: {
    label: 'Fallita',
    color: 'var(--danger)',
    soft: 'var(--danger-soft)',
    icon: 'alert-triangle',
    bordered: true,
  },
  cancelled: {
    label: 'Annullata',
    color: 'var(--faint)',
    soft: 'var(--neutral-soft)',
    icon: 'x-circle',
  },
};

export interface NodeMeta {
  label: string;
  border: string;
  dot: string;
  icon?: string;
  iconColor?: string;
  opacity?: number;
  band?: string;
  spinner?: boolean;
}

export const NODE_META: Record<NodeState, NodeMeta> = {
  dormant: {
    label: 'dormiente',
    border: '1px dashed var(--border)',
    dot: 'transparent',
    opacity: 0.45,
  },
  engaged: { label: 'ingaggiato', border: '1px solid var(--accent)', dot: 'var(--accent)' },
  working: {
    label: 'lavora',
    border: '1px solid var(--accent)',
    dot: 'var(--accent)',
    band: 'var(--accent)',
    spinner: true,
  },
  awaiting_human: {
    label: 'aspetta te',
    border: '1px solid var(--warn)',
    dot: 'var(--warn)',
    band: 'var(--warn)',
    icon: 'hand',
    iconColor: 'var(--warn)',
  },
  suspended: {
    label: 'sospeso · worker libero',
    border: '1px solid var(--faint)',
    dot: 'var(--faint)',
    icon: 'pause',
    iconColor: 'var(--faint)',
    opacity: 0.6,
  },
  released: {
    label: 'libero',
    border: '1px dashed var(--border)',
    dot: 'var(--faint)',
    opacity: 0.55,
  },
  failed: {
    label: 'errore',
    border: '2px solid var(--danger)',
    dot: 'var(--danger)',
    icon: 'alert-triangle',
    iconColor: 'var(--danger)',
  },
  draining: {
    label: 'DRAIN · GRACE',
    border: '1px dashed var(--border-strong)',
    dot: 'var(--faint)',
    opacity: 0.58,
  },
  placeholder: {
    label: 'slot elastico',
    border: '1px dashed var(--border)',
    dot: 'transparent',
    opacity: 0.35,
  },
};

export const CHANNEL_ICON: Record<string, string> = {
  text: 'keyboard',
  voice: 'mic',
  schedule: 'clock',
  trigger: 'zap',
  api: 'zap',
};
